import React, { useEffect, useRef } from 'react';
import './PausePopup.css';
import gsap from 'gsap';
import rockBg from '../../asserts/rockbg.png';
import Btn1 from '../common/Btn1';
import Btn5 from '../common/Btn5';

const PausePopup = ({ onResume, onLevels, onMenu }) => {
  const scrollRef = useRef();
  const contentRef = useRef();

  useEffect(() => {
    gsap.set(scrollRef.current, {
      rotation: 60,
      rotationX: -40,
      opacity: 0,
      transformOrigin: 'center center',
      transformPerspective: 1400,
      x: 100,
      y: 820,
      scale: 0.8,
    });
    const tl = gsap.timeline();
    tl.to(scrollRef.current, {
      rotation: 0,
      rotationX: 0,
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      duration: 1.3,
      ease: 'power3.out',
    }).fromTo(
      contentRef.current.querySelectorAll('.popup-animate'),
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out' },
      '-=0.4'
    );
  }, []);

  const animateClose = (cb) => {
    const tl = gsap.timeline({ onComplete: cb });
    tl.to(contentRef.current.querySelectorAll('.popup-animate'), {
      opacity: 0,
      y: 20,
      duration: 0.25,
      stagger: 0.06,
      ease: 'power2.in',
    }).to(scrollRef.current, {
      rotation: -20,
      rotationX: 40,
      opacity: 0,
      x: -200,
      y: 120,
      scale: 0.8,
      duration: 1,
      ease: 'power3.in',
    }, '-=0.1');
  };

  return (
    <div className="popup-overlay">
      <div className="popup-scroll" ref={scrollRef} style={{ backgroundImage: `url(${rockBg})` }}>
        <div className="popup-innner" ref={contentRef}>
          <h2 className="popup-title popup-animate">Time Frozen</h2>
          <p className="popup-subtitle popup-animate">The Shadow rests. The Scribe waits for your move.</p>
          <div className="pause-buttons popup-animate">
            <Btn5 label="Resume" onClick={() => animateClose(onResume)} />
            <Btn5 label="Levels" onClick={() => animateClose(onLevels)} />
            <Btn5 label="Menu" onClick={() => animateClose(onMenu)} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PausePopup;